import { rest } from "msw";
import { apiUrl } from "features/configure";
import { ticketMetrics, agentMetrics } from "./data/MockServiceReport";
import { users } from "./data/MockUsers";
import { tickets } from "./data/MockTicket";

const getCustomersList = rest.post(
  `${apiUrl}/api/user/:entityName/userList`,
  (req, res, ctx) => {
    const { entityName } = req.params;

    return res(
      ctx.status(200),
      ctx.json(users.list),
      ctx.set("x-total-count", "20")
    );
  }
);
const getTicketList = rest.get(
  `${apiUrl}/api/ticket/ticketList`,
  (req, res, ctx) => {
    const status = req.url.searchParams.get("status");
    let filteredData = tickets.list;
    if (status && status !== "All") {
      filteredData = filteredData.filter((item) => item.status == status);
    }
    return res(
      ctx.status(200),
      ctx.json(filteredData),
      ctx.set("x-total-count", "20")
    );
  }
);
const getTicketDetail = rest.get(
  `${apiUrl}/api/ticket/:ticketId`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(tickets.detail));
  }
);
const getTicketMessages = rest.get(
  `${apiUrl}/api/messages/ticket`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(tickets.messages));
  }
);

const getTicketAiConfig = rest.get(
  `${apiUrl}/api/aiSupport/gitbook/getConfig`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(tickets.aiConfig));
  }
);

const getUserRelatedTicket = rest.get(
  `${apiUrl}/api/ticket/user`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.set("x-total-count", "7"),
      ctx.json(users.tickets)
    );
  }
);
const getTicketUserInfo = rest.get(`${apiUrl}/api/user`, (req, res, ctx) => {
  const entityName = req.url.searchParams.get("entityName");

  return res(ctx.status(200), ctx.json(tickets.userInfo));
});

const getServiceReportChartData = rest.get(
  `${apiUrl}/api/ticket/analytics/:entityName/ticket`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(ticketMetrics));
  }
);

const getServiceReportAgentList = rest.get(
  `${apiUrl}/api/ticket/analytics/:entityName/agent`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(agentMetrics));
  }
);

export const ticketMocks = [
  getCustomersList,
  getTicketList,
  getTicketMessages,
  getTicketAiConfig,
  getUserRelatedTicket,
  getTicketUserInfo,
  getTicketDetail,
  getServiceReportChartData,
  getServiceReportAgentList,
];
